import { Check } from "lucide-react";

const SIZES = {
  sm: { text: "text-[10px]", dot: "w-3.5 h-3.5", tick: "w-2 h-2" },
  md: { text: "text-[12.5px]", dot: "w-4 h-4", tick: "w-2.5 h-2.5" },
};

/**
 * The verified mark for a Premium business — card, page and map pin.
 *
 * Kept to the social apps' own shorthand: a red check and the word, no box
 * around it. Pass label="" for the bare check where there is no room to spell
 * it out (a browse card).
 */
export default function VerifiedBadge({ label = "Verified", size = "md", className = "" }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span
      className={`inline-flex items-center gap-1 font-extrabold leading-none text-[#FF0000] ${s.text} ${className}`}
    >
      <span className={`inline-grid place-items-center shrink-0 rounded-full bg-[#FF0000] ${s.dot}`}>
        <Check className={s.tick} strokeWidth={4} color="#ffffff" />
      </span>
      {label}
    </span>
  );
}